import { render, staticRenderFns } from "./ChangeWarehouse.vue?vue&type=template&id=5dd3d537&"
import script from "./ChangeWarehouse.vue?vue&type=script&lang=js&"
export * from "./ChangeWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports